import CaladreTheme from "../../theme/Theme";
import sharedStyle from "../style";

const classes = {
  ...sharedStyle,
  appBar: {
    height: "80px",
    backgroundColor: CaladreTheme.custom.White,
    boxShadow: 3,
    [CaladreTheme.breakpoints.down("lg")]: {
      fontSize: "56px",
    },
    "& a": {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none",
      },
    },
    "& .MuiBox-root:nth-of-type(1)": {
      flexGrow: 1,
      display: { xs: "flex", lg: "none" },
      justifyContent: "end",
    },
    "& .MuiBox-root:nth-of-type(2)": {
      flexGrow: 1,
      display: { xs: "none", lg: "flex" },
      justifyContent: "end",
      "& div:first-of-type": {
        display: "flex",
        alignItems: "center",
        "& a .MuiButton-root": {
          fontSize: "16px",
          maxHeight: "46px",
          color: CaladreTheme.custom.White,
          backgroundColor: CaladreTheme.palette.secondary.main,
          [CaladreTheme.breakpoints.down("xl")]: {
            fontSize: "14px",
          },
        },
        "& a:nth-of-type(2) > .MuiButton-root": {
          mx: 1,
        },
        "& a:nth-of-type(3) > .MuiButton-root": {
          mr: 1,
        },
      },
      "& .MuiButtonGroup-root": {
        "& > a": {
          textDecoration: "none",
          marginTop: "16px",
          marginBottom: "16px",
          padding: "0 15px",
          [CaladreTheme.breakpoints.down("xl")]: {
            padding: "0 5px",
          },
          "&:nth-of-type(2)": {
            borderLeft: "1px solid rgba(0,0,0,0.2)",
            "&:not(:last-child)": {
              borderRight: "1px solid rgba(0,0,0,0.2)",
            },
          },
          "& .MuiButton-root": {
            fontSize: "16px",
            fontWeight: "bold",
            p: 0,
            border: "none",
            color: CaladreTheme.custom.Black,
            [CaladreTheme.breakpoints.down("xl")]: {
              fontSize: "14px",
            },
            "&:hover": {
              border: "none",
            },
          },
        },
      },
    },
    "& .MuiContainer-maxWidthXl": {
      padding: CaladreTheme.spacing(1, 3),
    },
    "& .MuiToolbar-root": {
      [CaladreTheme.breakpoints.up("lg")]: {
        minHeight: "80px",
      },
    },
    "& img": {
      height: "32px",
      [CaladreTheme.breakpoints.up("lg")]: {
        height: "50px",
      },
    },
  },
  fieldBtn: {
    marginBottom: CaladreTheme.spacing(0),
    padding: CaladreTheme.spacing(0),
    fontWeight: "bold",
    color: CaladreTheme.palette.primary.main,
    background: "none",
    "&:hover": {
      background: "none",
      borderColor: "transparent",
    },
    [CaladreTheme.breakpoints.down("lg")]: {
      justifyContent: "start",
      width: "100%",
      margin: CaladreTheme.spacing(0.8, 0),
      padding: CaladreTheme.spacing(1, 1),
      border: "none",
      borderRadius: "12px",
      backgroundColor: CaladreTheme.custom.Gray,
      "&:hover": {
        border: "none",
        color: "black",
        backgroundColor: CaladreTheme.custom.Gray,
      },
      "& .MuiTypography-body1": {
        marginLeft: CaladreTheme.spacing(0.5),
        fontSize: "12px",
      },
    },
    [CaladreTheme.breakpoints.down("md")]: {
      "& .MuiTypography-body1": {
        fontSize: "10px",
      },
    },
  },
  linkBtn: {
    textDecoration: "underline",
    "&:hover": {
      background: "none",
      borderColor: "transparent",
    },
  },
  footer: {
    backgroundColor: CaladreTheme.custom.Gray1,
    "& .MuiTypography-h6": {
      color: CaladreTheme.palette.primary.main,
    },
  },
  footerList: {
    paddingTop: CaladreTheme.spacing(5),
    paddingBottom: CaladreTheme.spacing(5),
    "& ul": {
      paddingLeft: CaladreTheme.spacing(0),
      marginBottom: 0,
      listStyle: "none",
    },
    "& li": {
      padding: CaladreTheme.spacing(0.5, 0),
    },
    "& .MuiGrid-item:nth-of-type(4), .MuiGrid-item:nth-of-type(3)": {
      [CaladreTheme.breakpoints.down("lg")]: {
        marginTop: CaladreTheme.spacing(3),
      },
    },
  },
  footerBaseline: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: CaladreTheme.spacing(2),
  },
  onlyDesktop: {
    display: "none",
    [CaladreTheme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  onlyMobile: {
    display: "none",
    [CaladreTheme.breakpoints.down("md")]: {
      display: "block",
    },
  },
  mobileMenu: {
    position: "absolute",
    top: "64px",
    left: 0,
    height: "calc(100vh - 64px)",
    width: "100%",
    padding: "24px",
    backgroundColor: "white",
    "& a": {
      display: "flex",
      padding: "16px 8px",
      textDecoration: "none",
      color: CaladreTheme.palette.primary.main,
      "&:nth-of-type(1), &:nth-of-type(2), &:nth-of-type(3)": {
        fontFamily: "PoppinsSemiBold, sans-serif",
      },
      "&:not(:last-child)": {
        borderBottom: "1px solid rgba(25, 25, 25, 0.5)",
      },
    },
  },
  selectedBtn: {
    backgroundColor: `${CaladreTheme.palette.primary.main} !important`,
  },
};
export default classes;
